import animateScrollTo from 'animated-scroll-to'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import { TextLH } from 'styles/components/typography'

import {
  SSHandlerSideMenu,
  SSHandlerSideMenuItem,
  SSHandlerSideMenuList,
  TextBox,
  Underline,
} from './styles'

class SSpyDesktopHandler extends React.Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    sectionsRefs: PropTypes.array.isRequired,
    afterComponent: PropTypes.object,
    sceneActiveIndex: PropTypes.number,
  }

  static defaultProps = {
    sceneActiveIndex: 0,
    afterComponent: null,
  }

  constructor(props) {
    super(props)

    this.state = {
      pageIsScrolling: false,
      activeIndex: -1,
      StickyBox: Fragment,
    }
  }

  componentDidMount() {
    this.setState({
      StickyBox: require('react-sticky-box').default,
    })
  }

  scrollToHandler = (element, index) => {
    this.setState(
      {
        pageIsScrolling: true,
        activeIndex: index,
      },
      () => {
        animateScrollTo(element.current, {
          speed: 300,
          verticalOffset: -100,
          cancelOnUserAction: false,
        }).then(() =>
          this.setState({ pageIsScrolling: false, activeIndex: -1 }),
        )
      },
    )
  }

  render() {
    const { afterComponent, items, sectionsRefs, sceneActiveIndex } = this.props
    const { pageIsScrolling, activeIndex, StickyBox } = this.state

    return (
      <StickyBox>
        <SSHandlerSideMenu>
          <SSHandlerSideMenuList>
            {items.map((value, key) => (
              <SSHandlerSideMenuItem
                isActive={
                  (sceneActiveIndex === key && !pageIsScrolling) ||
                  (activeIndex >= 0 && pageIsScrolling && activeIndex === key)
                }
                onClick={() => this.scrollToHandler(sectionsRefs[key], key)}
                key={key}
              >
                <TextBox>
                  <TextLH
                    dangerouslySetInnerHTML={{
                      __html: value.menuTitle || value.title,
                    }}
                  />
                </TextBox>
                <Underline />
              </SSHandlerSideMenuItem>
            ))}
          </SSHandlerSideMenuList>
          {afterComponent}
        </SSHandlerSideMenu>
      </StickyBox>
    )
  }
}

export default SSpyDesktopHandler
